import React from 'react';
import { MessageSquare, FileText, CreditCard, Code, Eye, Rocket } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
const stepIcons = [MessageSquare, FileText, CreditCard, Code, Eye, Rocket];
export function ProcessSection() {
  const {
    t
  } = useLang();
  return <section className="py-24 bg-dark-100 overflow-hidden" data-id="element-465" data-mp="p4dwva6t3vu9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-466" data-mp="1mqup410onj95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-467" data-mp="1msfivof6ay5y">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-468" data-mp="17zm2m0s2ue08">
            {t.process.title}{' '}
            <span className="text-gold" data-id="element-469" data-mp="25ixblt009trb">{t.process.titleHighlight}</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-470" data-mp="262e87ag8r7cm">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-dark-100 via-gold/30 to-dark-100 -translate-y-1/2 z-0" data-id="element-471" data-mp="26364knhnx93y"></div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 relative z-10" data-id="element-472" data-mp="1wdcrtj5sany4">
            {t.process.steps.map((step, index) => {
            const Icon = stepIcons[index];
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex flex-col items-center text-center group" data-id="element-473" data-mp="1nb3i2vicayls" data-mpi={index}>
                  <div className="w-16 h-16 rounded-full bg-dark border-2 border-white/10 flex items-center justify-center text-gray-400 group-hover:border-gold group-hover:text-gold group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all duration-300 mb-4 relative" data-id="element-474" data-mp="3b9nsfrrr5gli">
                    <Icon className="w-6 h-6" data-id="element-475" data-mp="31dklm8lygts8" />
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gold text-dark text-xs font-bold rounded-full flex items-center justify-center" data-id="element-476" data-mp="2wd6i93vau80j">
                      {index + 1}
                    </div>
                  </div>
                  <h3 className="text-white font-bold mb-1" data-id="element-477" data-mp="3p1ua5iajzvn2">{step.title}</h3>
                  <p className="text-gray-500 text-xs" data-id="element-478" data-mp="3k916yyuqgvd3">{step.desc}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}